import React, { useState } from 'react';
import StackedSwipeView from '../StackedSwipeView';
import ConnectionsHubPage from '../../../connection/ConnectionsHubPage';
import { ConnectionHubPage } from '../../../../gql/types';
import PlaceholderCard from '../../card/PlaceholderCard';

interface ConnectionsHubViewProps {
    pages: ConnectionHubPage[];
    isSelectMode: boolean;
    triggerPrevSignal: number;
    setEnablePrevButton: (val: boolean) => void;
}

const ConnectionsHubView: React.FC<ConnectionsHubViewProps> = ({
    pages,
    isSelectMode,
    triggerPrevSignal,
    setEnablePrevButton,
}) => {
    const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

    const handleToggle = (connectionIds: string[]) => {
        setSelectedIds((prev) => {
            const updated = new Set(prev);
            for (const id of connectionIds) {
                if (updated.has(id)) {
                    updated.delete(id);
                } else {
                    updated.add(id);
                }
            }
            return new Set(updated); // ensure new reference to trigger re-render
        });
    };

    return (
        <StackedSwipeView
            items={pages}
            triggerPrevSignal={triggerPrevSignal}
            setEnablePrevButton={setEnablePrevButton}
            renderCard={(page) => (
                <ConnectionsHubPage
                    page={page}
                    isSelectMode={isSelectMode}
                    selectedIds={selectedIds}
                    onToggle={handleToggle}
                />
            )}
            renderPlaceholder={() => (
                <PlaceholderCard
                    message="Swipe back to revisit previous pages or check back later."
                />
            )}
            onSwipeNext={() => {
                setSelectedIds(new Set());
            }}
        />
    );
};

export default ConnectionsHubView;
